import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const savedLang = localStorage.getItem('payflow_lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: { escapeValue: false },
  });

export default i18n;